import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalDialog, Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { Field, reduxForm } from "redux-form";
import LocaleStrings from "Languages";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { classNames, COMMON_FAIL_MESSAGE } from "Constants";
import {
  uploadreportedAttachments,
  addAdminReports,
  addReports_tracker,
  fetchadminissueTokenOpen,
  sendnewticketEmailtoclient,
  sendnewsupportTicketetointernal,
} from "AccountSettingsAction";
import { showError, showSuccess } from "ReduxErrorBar";
import AppIcons from "AppIcons";

class Addreports extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      btnLoading: false,
      selectedPlatform: "ios",
      fileArr: [],
      eventbased: "all",
      eventid: "",
    };
  }

  closeModals = () => {
    this.setState({ fileArr: [] });
    this.props.onClose();
  };

  renderFieldRadio1(field) {
    return (
      <div>
        <label
          className="custom-container-radio liveqa-label"
          style={{ marginBottom: 5 }}>
          {field.label}
          <input {...field.input} type={field.type} />
          <span className="radiomark"></span>
        </label>
      </div>
    );
  }
  renderFieldRadio(field) {
    return (
      <div>
        <label
          className="custom-container-radio liveqa-label"
          style={{ marginBottom: 5 }}>
          {field.label}
          <input {...field.input} type={field.type} />
          <span className="radiomark"></span>
        </label>
      </div>
    );
  }

  handleSelectplatform = (e) => {
    this.setState({ selectedPlatform: e.target.value });
  };
  _handleUnSelect = (e, i) => {
    var attachmentDeleteItem = this.state.fileArr;
    attachmentDeleteItem.splice(i, 1); // first element removed
    this.setState({ fileArr: attachmentDeleteItem });
    this.props.change(this.props.pristine, false);
  };

  _handleSelect(event) {
    let { fileArr } = this.state;
    if (fileArr.length > 4) {
      this.props.showError("Can upload upto 5 files");
      return false;
    }
    const reader = new FileReader(); // Define reader
    let file = event.target.files[0]; // Take Selected file
    reader.readAsArrayBuffer(file); // Read the file

    // On File Load
    reader.onload = (e) => {
      file.url = e.target.result;
    };

    this.setState({ fileName: file.name });
    //this.props.autofill(typeindex,file.name);

    fileArr.push(file);
    this.setState({ fileArr: fileArr });
    this.props.change(this.props.pristine, false);
  }
  getRandomNum() {
    return _.random(10000);
  }
  handleEventBased = (e) => {
    this.setState({ eventbased: e.target.value });
  };
  onSubmitForm = (values) => {
    let { session, user, alleventsunderClient } = this.props;

    let { eventbased } = this.state;
    let groupNumber = user.groupNumber;
    let clientid = user.clientid;
    this.setState({ loading: true });
    let attachmentNames = [];
    let uploaderCounter = 0;
    let filetobeupload = [];
    let arrPromise = [];
    let tokenno = this.getRandomNum();
    var data1 = {
      tokenno: tokenno,
      group_number: user.groupNumber,
      clientidfk: user.clientid,
      reportedby: user.clientid,
      platform: values.platform,
      status: "open",
    };

    if (eventbased == "event" && values.eventdata) {
      data1.eventid = parseInt(values.eventdata.value);
      data1.eventname = values.eventdata.label;
    }

    if (
      this.props.alleventsunderClient &&
      this.props.alleventsunderClient.length == 1
    ) {
      data1.eventid = parseInt(this.props.alleventsunderClient[0].eventid);
      data1.eventname = this.props.alleventsunderClient[0].eventname;
    }
    if (this.state.fileArr.length > 0) {
      _.forEach(this.state.fileArr, function (value, index) {
        let currentUnixTimestamp = Date.now();
        let ext = value.name.split(".").pop();
        let value_attachment_name =
          "attachment_" + currentUnixTimestamp + "_" + index + "." + ext;
        let replaced_attachementnames = `clients/${clientid}/supportticket/${value_attachment_name}`;
        attachmentNames.push(replaced_attachementnames);
        // attachmentNames.push(
        //   // `eventify/supportticket/${value.name}`
        //   `clients/${user.clientid}/supportticket/${value.name}`
        // );

        let coverJson = {
          type: value.type,
          name: replaced_attachementnames,
          media: value.url,
        };

        filetobeupload.push(coverJson);
      });

      let counter = filetobeupload.length;

      filetobeupload.map((item, index) => {
        arrPromise.push(
          new Promise((resolve, reject) => {
            this.props.uploadreportedAttachments(
              this.props.session,
              item,
              user.clientid,
              (response) => {
                if (response.success === 0) {
                  resolve();
                } else {
                  uploaderCounter++;
                  resolve();
                }
              }
            );
          })
        );
      });

      values["attachments"] = _.join(attachmentNames, ",");
      var data2 = {
        repliedby: user.clientid,
        subject: values.subject,
        description: values.description,
        attachments: values.attachments,
      };
      this.props.addAdminReports(this.props.session, data1, (response) => {
        data2.reportissueidfk = response?.data?.resource[0].id;
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.props.addReports_tracker(
            this.props.session,
            data2,
            (response1) => {
              if (response1.success === 0) {
                this.setState({ loading: false });
                // alert("error");
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                this.props.fetchadminissueTokenOpen(
                  this.props.session,
                  clientid,
                  (CallBackResponse) => {
                    this.setState({ loading: false });
                    this.props.onClose();
                    this.props.showSuccess(
                      LocaleStrings.accountsetting_addreport_addedsuccess
                    );
                    let emailobj = {};
                    let sendnewticketEmailtointernalobj = {};
                    emailobj.id = response?.data?.resource[0].id;
                    emailobj.type = "sendnewsupportTicketemail";
                    emailobj.clientid = clientid;
                    emailobj.clientid = clientid;
                    sendnewticketEmailtointernalobj.id =
                      response?.data?.resource[0].id;
                    sendnewticketEmailtointernalobj.type =
                      "sendnewsupportTicketetointernal";
                    sendnewticketEmailtointernalobj.clientid = clientid;
                    sendnewticketEmailtointernalobj.newticket = 1;
                    this.props.sendnewticketEmailtoclient(
                      session,
                      emailobj,
                      (response) => {}
                    );
                    this.props.sendnewsupportTicketetointernal(
                      session,
                      sendnewticketEmailtointernalobj,
                      (response) => {}
                    );
                  }
                );
              }
            }
          );
        }
      });
    } else {
      var data2 = {
        repliedby: user.clientid,
        subject: values.subject,
        description: values.description,
      };
      // console.log("values", values);
      // debugger;

      this.props.addAdminReports(this.props.session, data1, (response) => {
        data2.reportissueidfk = response?.data?.resource[0].id;
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.props.addReports_tracker(
            this.props.session,
            data2,
            (response1) => {
              if (response1.success === 0) {
                this.setState({ loading: false });
                // alert("error");
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                this.props.fetchadminissueTokenOpen(
                  this.props.session,
                  clientid,
                  (CallBackResponse) => {
                    this.setState({ loading: false });
                    this.props.onClose();
                    this.props.showSuccess(
                      LocaleStrings.accountsetting_addreport_addedsuccess
                    );
                    let emailobj = {};
                    let sendnewticketEmailtointernalobj = {};
                    emailobj.id = response?.data?.resource[0].id;
                    emailobj.type = "sendnewsupportTicketemail";
                    emailobj.clientid = clientid;
                    sendnewticketEmailtointernalobj.id =
                      response?.data?.resource[0].id;
                    sendnewticketEmailtointernalobj.type =
                      "sendnewsupportTicketetointernal";
                    sendnewticketEmailtointernalobj.clientid = clientid;
                    this.props.sendnewticketEmailtoclient(
                      session,
                      emailobj,
                      (response) => {}
                    );
                    this.props.sendnewsupportTicketetointernal(
                      session,
                      sendnewticketEmailtointernalobj,
                      (response) => {}
                    );
                  }
                );
              }
            }
          );
        }
      });
    }
  };

  render() {
    let {
      session,
      handleSubmit,
      reportPlatforms,
      eventBasedData,
      alleventsunderClient,
    } = this.props;
    var fileStyle = {
      paddingRight: "10px",
      marginRight: "10px",
      border: "1px solid #e6edf3",
      padding: "10px",
      background: "#fff",
      width: "100%",
    };
    var alleventOpts = [];
    if (alleventsunderClient) {
      _.forEach(this.props.alleventsunderClient, function (value) {
        var obj = {
          label: value.eventname,
          value: value.eventid.toString(),
        };

        alleventOpts.push(obj);
      });
    }

    return (
      <Modal
        show={this.props.isOpen}
        onHide={this.closeModals}
        className=""
        dialogClassName="contact-eventify-modal">
        <Modal.Header>
          <Modal.Title>
            <div className="title-modal">
              {LocaleStrings.accountsetting_postfeedback}
            </div>
          </Modal.Title>
          <button
            type="button"
            className="i-custom-cross-popup pull-right"
            onClick={this.closeModals}>
            <img
              className="i-custom-small"
              src="../../style/images/custom-icons/cross-black.png"
            />
          </button>
        </Modal.Header>
        <form onSubmit={handleSubmit(this.onSubmitForm)}>
          <Modal.Body>
            {/* <label className="control-label-top col-sm-12">
              Platform
            </label> */}
            {this.props.alleventsunderClient &&
            this.props.alleventsunderClient &&
            this.props.alleventsunderClient.length > 1 ? (
              <div className="form-group" style={{ display: "flex" }}>
                {_.map(eventBasedData, (opt, index) => {
                  return (
                    <div key={index} style={{ marginBottom: 5 }}>
                      <Field
                        name="eventbased"
                        label={opt.name}
                        value={opt.value}
                        type="radio"
                        component={this.renderFieldRadio1}
                        onChange={this.handleEventBased}
                      />
                    </div>
                  );
                })}
              </div>
            ) : (
              ""
            )}

            {this.state.eventbased == "event" ? (
              // <Field
              //   name="eventid"
              //   label={LocaleStrings.accountsetting_addreport_labelevent}
              //   placeholder={LocaleStrings.user_form_label_select_events}
              //   component={this.renderSelect}
              //   mandatory="true"
              //   labelposition={LABEL_POSITION_TOP}
              //   opts={alleventOpts}
              // />

              <Field
                name="eventdata"
                label={LocaleStrings.accountsetting_addreport_labelevent}
                placeholder={LocaleStrings.user_form_label_select_events}
                component={this.renderAutoComplete}
                mandatory="false"
                options={alleventOpts}
              />
            ) : (
              ""
            )}

            <label className="control-label-top col-sm-12">
              {LocaleStrings.accountsetting_addreport_labelplatform}
            </label>
            <div className="form-group" style={{ display: "flex" }}>
              {_.map(reportPlatforms, (opt, index) => {
                return (
                  <div key={index} style={{ marginBottom: 5 }}>
                    <Field
                      name="platform"
                      label={opt.name}
                      value={opt.value}
                      type="radio"
                      component={this.renderFieldRadio}
                      onChange={this.handleSelectplatform}
                    />
                  </div>
                );
              })}
            </div>
            <Field
              name="subject"
              label={LocaleStrings.accountsetting_fieldsubject}
              placeholder={LocaleStrings.accountsetting_placeholdersubject}
              type="text"
              component={this.renderFieldText}
              mandatory="true"
              labelposition={LABEL_POSITION_TOP}
            />

            <Field
              name="description"
              label={LocaleStrings.accountsetting_descfield}
              mandatory="false"
              type="minimal"
              // mandatory="false"
              component={this.renderRichTextareaWithLabelTinymce}
              labelposition={LABEL_POSITION_TOP}
              height={250}
            />
            {/* <Field
              name="description"
              label={LocaleStrings.accountsetting_placeholdersubject}
              placeholder={LocaleStrings.accountsetting_descfield}
              component={this.renderFieldTextarea}
              mandatory="true"
              labelposition={LABEL_POSITION_TOP}
            /> */}
            <div className="">
              <div className="" style={{ display: "flex" }}>
                <span
                  className="text-sm "
                  style={{ color: "#000", width: "100%" }}>
                  {_.size(this.state.fileArr) > 0 ? (
                    <div style={{ marginTop: "10px" }}>
                      <p>
                        {LocaleStrings.accountsetting_addreport_uploadfile}{" "}
                        <span style={{ color: "#2776EA" }}>
                          {LocaleStrings.accountsetting_addreport_max5files}
                        </span>
                      </p>
                      {_.map(this.state.fileArr, (value, index) => {
                        return (
                          <div
                            style={{
                              display: "flex",
                              marginTop: "10px",
                            }}>
                            <div className="user-attachments" style={fileStyle}>
                              {value.name}
                            </div>

                            <button
                              className={classNames(
                                _.size(this.state.fileArr) > 0
                                  ? "i-custom-table-delete "
                                  : "hidden i-custom-table-delete"
                              )}
                              style={{ marginTop: "5px" }}
                              type="button"
                              onClick={(e) => this._handleUnSelect(e, index)}>
                              <img
                                className={classNames(
                                  _.size(this.state.fileArr) > 0
                                    ? "i-custom-table"
                                    : "hidden i-custom-table",
                                  "h-4 w-4  cursor-pointer"
                                )}
                                src="../../style/images/custom-icons/shape-1317-copy-3.svg"
                              />
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    ""
                  )}
                </span>
              </div>
              {_.size(this.state.fileArr) < 5 ? (
                <div
                  className="flex"
                  style={{
                    textAlign: "end",
                    cursor: "pointer",
                    marginTop: "5px",
                  }}>
                  <label
                    htmlFor="attachment"
                    className="relative cursor-pointer user-attachments"
                    style={{
                      border: "1px solid #e6edf3",
                      padding: "10px",
                      background: "#fff",
                      cursor: "pointer",
                    }}>
                    <span className="font-icomoon i-custom-ms">
                      {AppIcons.uploadericon}
                    </span>
                    <span>{LocaleStrings.attach_files}</span>
                    <input
                      id="attachment"
                      name="attachment"
                      type="file"
                      // accept="image/*"
                      className="sr-only"
                      onChange={(e) => this._handleSelect(e)}
                    />
                  </label>
                </div>
              ) : (
                ""
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <div className="pull-left h-100 vertical-align-center"></div>
              <div
                className="pull-right h-100 vertical-align-center"
                style={{ marginLeft: "auto" }}>
                <Button variant="secondary" onClick={this.closeModals}>
                  {
                    LocaleStrings.accountsetting_billingdetails_contacteventify_modalclose
                  }
                </Button>
                <Button
                  className="btn-custom-blue"
                  loading={this.state.loading}
                  type="submit"
                  style={{ marginLeft: "10px" }}>
                  {LocaleStrings.accountsetting_report_issue_send}
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}
function validate(values) {
  // console.log('values',values);
  var errors = {};
  var requiredFields = ["subject", "description"];
  requiredFields.forEach((field) => {
    if (!values[field] || values[field].trim() === "") {
      errors[field] = "Required";
    }
  });
  return errors;
}
function mapStateToProps(state) {
  let initval = { platform: "ios", eventbased: "all" };
  return {
    session: state.session,
    user: state.user,
    reportPlatforms: state.reportPlatforms,
    eventBasedData: state.eventBasedData,
    initialValues: initval,
    alleventsunderClient: state.alleventsunderClient.data
      ? state.alleventsunderClient.data
      : [],
  };
}
export default connect(mapStateToProps, {
  uploadreportedAttachments,
  addAdminReports,
  addReports_tracker,
  fetchadminissueTokenOpen,
  showError,
  showSuccess,
  sendnewticketEmailtoclient,
  sendnewsupportTicketetointernal,
})(
  reduxForm({
    validate,
    form: "AddreportsModalForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(Addreports)
);
